var _circle, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#191733"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.29289 4.79289C4.68342 4.40237 5.31658 4.40237 5.70711 4.79289L13.2071 12.2929C13.5976 12.6834 13.5976 13.3166 13.2071 13.7071C12.8166 14.0976 12.1834 14.0976 11.7929 13.7071L4.29289 6.20711C3.90237 5.81658 3.90237 5.18342 4.29289 4.79289Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 15.5L15 9.5L18.5 13C20.1569 14.6569 20.1569 17.3431 18.5 19C16.8431 20.6569 14.1569 20.6569 12.5 19L9 15.5ZM13.0945 15.6434L15.1598 13.5781L16.3646 14.7829C16.9349 15.3532 16.9349 16.2779 16.3646 16.8482C15.7943 17.4185 14.8696 17.4185 14.2993 16.8482L13.0945 15.6434Z",
    fill: "url(#paint0_linear_3346_32818)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.88388 4.61612C5.39573 4.12796 4.60427 4.12796 4.11612 4.61612C3.62796 5.10427 3.62796 5.89573 4.11612 6.38388L10.9394 13.2071L8.64648 15.5L12.3233 19.1768C14.0777 20.9313 16.9223 20.9313 18.6768 19.1768C20.4313 17.4223 20.4313 14.5777 18.6768 12.8233L15 9.14648L12.7071 11.4394L5.88388 4.61612ZM11.6474 13.2062L11.6465 13.2071L11.6484 13.209L11.2948 13.5626L11.2929 13.5607L9.35359 15.5L12.6768 18.8233C14.236 20.3825 16.764 20.3825 18.3233 18.8233C19.8825 17.264 19.8825 14.736 18.3233 13.1768L15 9.85359L13.0607 11.7929L13.0626 11.7948L12.709 12.1484L5.53033 4.96967C5.23744 4.67678 4.76256 4.67678 4.46967 4.96967C4.17678 5.26256 4.17678 5.73744 4.46967 6.03033L11.2929 12.8536L11.2939 12.8526L11.6474 13.2062ZM16.5661 14.5254L15.1205 13.0798L12.596 15.6043L14.0416 17.0499C14.7387 17.747 15.8689 17.747 16.5661 17.0499C17.2632 16.3528 17.2632 15.2225 16.5661 14.5254ZM14.3657 16.7258L13.2443 15.6043L15.1205 13.7281L16.2419 14.8496C16.76 15.3677 16.76 16.2077 16.2419 16.7258C15.7238 17.2439 14.8838 17.2439 14.3657 16.7258Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3346_32818",
    x1: 14.3713,
    y1: 9.5,
    x2: 14.3713,
    y2: 20.2426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A66D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7CB53"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDig);
export default __webpack_public_path__ + "static/media/dig.348b693ad0e3a81891007745af1a18b5.svg";
export { ForwardRef as ReactComponent };